import React from "react"
import Dashboard from '../dashboard/Dashboard'
import Products from '../Products/Products'
import Orders from '../Orders/Orders'
import AdminUsers from '../AdminUsers/AdminUsers'
import RegisteredUsers from '../RegisteredUsers/RegisteredUsers'
import Categories from '../Categories/Categories'
import ContactMessages from '../ContactMessages/ContactMessages'
import Customers from '../Customers/Customers'
import Carts from '../Carts/Carts'
import Reviews from '../Reviews/Reviews'
import DeliveryBoys from '../DeliveryBoys/DeliveryBoys'
import Promotions from '../Promotions/Promotions'
import Announcements from '../Announcements/Announcements'
import Logs from '../Logs/Logs'
import Settings from '../Settings/Settings'
import Returns from '../Returns/Returns'

const components = {
    Home: Dashboard,
    Products,
    Orders,
    Categories,
    ContactMessages,
    Customers,
    Carts,
    Reviews,
    DeliveryBoys,
    Promotions,
    Announcements,
    Returns,
    Logs,
    AdminUsers,
    RegisteredUsers,
    Settings
}
function Component(props) {
    const DynamicComponent = components[props.selectedSection]
    if (!components[props.selectedSection]) {
        return <p>Component is not defined: {props.selectedSection}</p>
    }

    return <DynamicComponent {...props} />
}

export { Component }